import { createSlice } from "@reduxjs/toolkit";

const initValue = {
  theme: { themeName: "dark" },
};

const themeSlice = createSlice({
  name: "theme",
  initialState: initValue,
  reducers: {
    changeTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

const { actions, reducer } = themeSlice;

export const { changeTheme } = actions;

export default reducer;
